var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitchHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-stroke/switch-horizontal-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M30.0004 25.5H6.00037M6.00037 25.5L12.0004 19.5M6.00037 25.5L12.0004 31.5M6.00037 10.5H30.0004M30.0004 10.5L24.0004 4.5M30.0004 10.5L24.0004 16.5",
    stroke: "#46C3B2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchHorizontal);
export default __webpack_public_path__ + "static/media/switch-horizontal.4b16b7f7599bbf4658cd8508a775c032.svg";
export { ForwardRef as ReactComponent };